export default {
  "SO_SA04": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "",
    "view": "SaledeliveryView",
    "controller": "SaledeliveryController",
    "templateName": "saledeliveryTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleDeliveryDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }, {
        Name: 'saledeliveryActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA04_detail": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "detail",
    "view": "SaledeliveryEditDetailView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryEditDetailTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleDeliveryDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }
    ]
  },
  "SO_SA04_settlement": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "settlement",
    "view": "SaledeliverySettlementView",
    "templateName": "saledeliverySettlementTemplates",
    "PCTemplateSysName": "",
    "PCTemplateMidHeadName": "",
    "PCTemplateMidBodyName": "",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA04_priceavailable": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "priceavailable",
    "view": "SaledeliveryPriceAvailableView",
    "templateName": "saledeliveryPriceAvailableTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'bodyTemplates',
        IsDetial: true,
        IsAction: false
      },
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyActions',
        IsDetial: true,
        IsAction: true
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA04_allbatchlist": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "allbatchlist",
    "view": "SaledeliveryBatchListView",
    "templateName": "saledeliveryBatchListTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'bodyTemplates',
        IsDetial: true,
        IsAction: false
      },
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyActions',
        IsDetial: true,
        IsAction: true
      }
    ]
  },

  "SO_SA04_voucherdetail": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "voucherdetail",
    "view": "SaledeliveryVoucherDetailView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryVoucherDetailTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleDeliveryDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  //价格参考
  "SO_SA04_referprice": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "referprice",
    "view": "SaledeliveryReferPriceView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryVoucherDetailTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleDeliveryDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },

  "SO_SA04_promotionitem": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "promotionitem",
    "view": "PromotionPlanListView",
    "detailName": "SaleDeliveryDetails",
    "templateName": "saledeliveryTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "viewModeName": 'OrderVoucherModel',
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "templateStructure": [
      
    ]
  },

  "SO_SA04_prereceiveselist": {
    "sysid": "SO",
    "mid": "SA04",
    "pid": "prereceiveselist",
    "view": "PreReceiveseListView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "preReceiveseListTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleDeliveryDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleDeliveryDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  



  "SO_SA03": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "",
    "view": "SaledeliveryView",
    "controller": "SaledeliveryController",
    "templateName": "saledeliveryTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }, {
        Name: 'saledeliveryActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA03_detail": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "detail",
    "view": "SaledeliveryEditDetailView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryEditDetailTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }
    ]
  },

  "SO_SA03_referprice": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "referprice",
    "view": "SaledeliveryReferPriceView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryEditDetailTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }
    ]
  },
  
  "SO_SA03_priceavailable": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "priceavailable",
    "view": "SaledeliveryPriceAvailableView",
    "templateName": "saledeliveryPriceAvailableTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'bodyTemplates',
        IsDetial: true,
        IsAction: false
      },
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyActions',
        IsDetial: true,
        IsAction: true
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },

  "SO_SA03_multisettle": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "multisettle",
    "view": "SaledeliveryPriceAvailableView",
    "controller": "SaledeliveryController",
    "templateName": "saledeliveryMultiSettlementTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'bodyActions',
        DetailName: 'DetailsAction',
        IsDetial: true,
        IsAction: true
      }, {
        Name: 'saledeliveryActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA03_promotionitem": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "promotionitem",
    "view": "PromotionPlanListView",
    "detailName": "SaleOrderDetails",
    "templateName": "saledeliveryTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "viewModeName": 'OrderVoucherModel',
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "templateStructure": [
      
    ]
  },

  "SO_SA03_settlement": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "settlement",
    "view": "SaledeliverySettlementView",
    "templateName": "saledeliveryMultiSettlementTemplates",
    "PCTemplateSysName": "",
    "PCTemplateMidHeadName": "",
    "PCTemplateMidBodyName": "",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
  "SO_SA03_allbatchlist": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "allbatchlist",
    "view": "SaledeliveryBatchListView",
    "templateName": "saledeliveryBatchListTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'bodyTemplates',
        IsDetial: true,
        IsAction: false
      },
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyActions',
        IsDetial: true,
        IsAction: true
      }
    ]
  },
  "SO_SA03_voucherdetail": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "voucherdetail",
    "view": "SaledeliveryVoucherDetailView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "saledeliveryVoucherDetailTemplates",
    "PCTemplateSysName": "SaleOrder",
    "PCTemplateMidHeadName": "SaleOrderHead",
    "PCTemplateMidBodyName": "SaleOrderDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  }
,
  "SO_SA03_prereceiveselist": {
    "sysid": "SO",
    "mid": "SA03",
    "pid": "prereceiveselist",
    "view": "PreReceiveseListView",
    "controller": "SaledeliveryEditDetailController",
    "templateName": "preReceiveseListTemplates",
    "PCTemplateSysName": "SaleDelivery",
    "PCTemplateMidHeadName": "SaleDeliveryHead",
    "PCTemplateMidBodyName": "SaleDeliveryDetails",
    "detailName": "SaleOrderDetails",
    "headerTemplateName": "headerTemplates",
    "detailTemplateName": "bodyTemplates",
    "viewModeName": 'OrderVoucherModel',
    "templateStructure": [
      {
        Name: 'headerTemplates',
        IsDetial: false,
        IsAction: false
      }, {
        Name: 'bodyTemplates',
        DetailName: 'SaleOrderDetails',
        IsDetial: true,
        IsAction: false
      }, {
        Name: 'headerActions',
        IsDetial: false,
        IsAction: true
      }
    ]
  },
}
